/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LogoFigmaIcon16Light } from './LogoFigmaIcon16Light';
import { LogoFigmaIcon16Regular } from './LogoFigmaIcon16Regular';
import { LogoFigmaIcon16Solid } from './LogoFigmaIcon16Solid';
import { LogoFigmaIcon20Light } from './LogoFigmaIcon20Light';
import { LogoFigmaIcon20Regular } from './LogoFigmaIcon20Regular';
import { LogoFigmaIcon20Solid } from './LogoFigmaIcon20Solid';
import { LogoFigmaIcon24Regular } from './LogoFigmaIcon24Regular';
import { LogoFigmaIcon24Solid } from './LogoFigmaIcon24Solid';
import { LogoFigmaIcon32Regular } from './LogoFigmaIcon32Regular';
import { LogoFigmaIcon64Regular } from './LogoFigmaIcon64Regular';
var sizes = {
    16: {
        light: LogoFigmaIcon16Light,
        regular: LogoFigmaIcon16Regular,
        solid: LogoFigmaIcon16Solid,
    },
    20: {
        light: LogoFigmaIcon20Light,
        regular: LogoFigmaIcon20Regular,
        solid: LogoFigmaIcon20Solid,
    },
    24: {
        regular: LogoFigmaIcon24Regular,
        solid: LogoFigmaIcon24Solid,
    },
    32: {
        regular: LogoFigmaIcon32Regular,
    },
    64: {
        regular: LogoFigmaIcon64Regular,
    },
};
export var LogoFigmaIcon = forwardRef('LogoFigmaIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
